import type {TopicItemDto} from "../../dibAppApi/dibAppApi";
import {useCallback} from "react";
import {noteTopicEntry} from "../content/topicEntryNote";
import {bffApi} from "./bffApi";
import {topicOpenFromUrl} from "./topicOpenMetrics";

export function usePortalOpenAnalytics() {
    const [trackOpened] = bffApi.endpoints.trackOpened.useMutation();
    return useCallback((portalId: number, portalType: string, href: string | null | undefined, position?: number) => {
        const key = String(portalId);
        void trackOpened({entity: "portal", key, portalType, position});
        // The topic page records the topic open itself; this only says how it was reached.
        noteTopicEntry(topicOpenFromUrl(href)?.key, "portal");
    }, [trackOpened]);
}

/** My Work: pinned items are favourites, last visited items are history. */
export function useWorkTopicOpenAnalytics() {
    return useCallback((item: TopicItemDto, section: "lastvisited" | "pinned") => {
        noteTopicEntry(item.id, section === "pinned" ? "favorite" : "history");
    }, []);
}
